import { BotConfiguration, BotMetadata, EnvironmentType } from '@feedyou/schema'

export function getEnvironmentName<Expected extends EnvironmentType | undefined>(
  descriptor: BotConfiguration | BotMetadata | null | undefined,
  expectedType?: Expected
): Expected extends EnvironmentType ? string : string | undefined {
  if (!descriptor) {
    if (expectedType) {
      return verbalizeEnv(expectedType)
    }

    // @ts-ignore
    return undefined
  }

  const { environmentType, environmentName } = descriptor

  if (environmentName) {
    return environmentName
  }

  return verbalizeEnv(environmentType)
}

function verbalizeEnv(env: EnvironmentType) {
  return env === 'test' ? 'Test' : 'Production'
}
